__turbopack_context__.v({
  "select": "LanguageSelect-module-scss-module__So1LdG__select",
  "select-selected": "LanguageSelect-module-scss-module__So1LdG__select-selected",
});
